export default "/opensea-logo.3930ddfafabc9e4ff6dcb8e0d22d041f.png";